import { z } from 'zod';

import { mainstreamCountriesQueryOptions } from '@/hooks/queries/use-mainstream-countries';
import { queryClient } from '@/lib/query-client';
import type { CountryPostalCodeUse } from '@/services/api/mainstream/countries';

export const mainstreamCountrySchema = (message?: string) =>
  z
    .string({ error: message })
    .min(1, { message })
    .refine(
      async (value) => {
        const countries = await queryClient.ensureQueryData(mainstreamCountriesQueryOptions);

        return countries && value in countries;
      },
      { message },
    );

export const getCountryPostalCodeUse = async (countryCode: string): Promise<CountryPostalCodeUse> => {
  const countries = await queryClient.ensureQueryData(mainstreamCountriesQueryOptions);

  return countries?.[countryCode]?.postalCodeUse ?? 'required';
};

// A country without an `eu` flag counts as EU, as on the server, so a TIN stays required until it is flagged
export const getCountryIsEu = async (countryCode: string): Promise<boolean> => {
  const countries = await queryClient.ensureQueryData(mainstreamCountriesQueryOptions);

  return countries?.[countryCode]?.eu !== false;
};
